// extracted by mini-css-extract-plugin
export default {"badge":"SubscriptionStatusBadge_badge__HSnQJ"};